import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonIcon,
  IonLabel,
} from '@ionic/react';
import { openOutline } from 'ionicons/icons';
import { ReactElement } from 'react';
import { Machine } from '../../../api/graphql/generated';
import { useMonitorLogs } from '../../../api/hooks/monitor-logs.hooks';
import { trackExternalLink } from '../../../config/analytics';
import { ApplicationConfig } from '../../../config/config';
import i18n from '../../../i18n';
import { useBeaconRouter } from '../../../route/route.hooks';
import { LogMessage } from '../machine-logs';

interface IOCardProps {
  machine?: Machine;
}

const LogsCard = (props: IOCardProps): ReactElement => {
  const { machine } = props;

  const logs = useMonitorLogs(machine?.id, 5);

  const { builder } = useBeaconRouter();

  return (
    <IonCard
      className="machine-card-container"
      routerLink={
        machine
          ? builder.getMachineLogsRoute(machine.teamId, machine.id)
          : undefined
      }
    >
      <IonCardHeader>
        <IonCardTitle>{i18n.t('common:machine_logs_recent')}</IonCardTitle>
      </IonCardHeader>
      {logs.length === 0 ? (
        <LogHelp />
      ) : (
        <div className="machine-card-log-messages">
          {logs.map((log) => {
            return (
              <LogMessage
                key={log.messageId}
                log={log}
                ionItemProps={{ lines: 'none' }}
              />
            );
          })}
        </div>
      )}
    </IonCard>
  );
};

const LogHelp = (): ReactElement => {
  const color = 'medium';
  const url = ApplicationConfig.assets.loggingTutorial;

  return (
    <a href={url} target="_blank" rel="noreferrer">
      <div
        className="machine-card-info-grid"
        onClick={(e) => {
          trackExternalLink(`Tutorial - Logging`, url);
          e.stopPropagation();
        }}
      >
        <IonLabel className="machine-card-info-grid-label" color="medium">
          <p>{i18n.t('common:logging_tutorial')}</p>
        </IonLabel>
        <IonIcon
          className="machine-card-info-grid-value"
          icon={openOutline}
          color={color}
        />
      </div>
    </a>
  );
};

export { LogsCard };
